import type { Dayjs } from "dayjs";

/**
 * `selectedDate` from `useCalendarStore` is pinned to `dayjs().locale("sl")`,
 * so formatting it directly leaks Slovenian weekday names whatever the app
 * language is. Re-apply the active locale so `dddd` follows the UI language.
 */
export function formatListDayHeader(date: Dayjs, locale: string): string {
  return date.locale(locale).format("dddd, D. M. YYYY");
}
